import React from "react";
import styled from "@emotion/styled";

interface ContainerProps {
  children: React.ReactNode;
  display?: string;
  gap?: string;
  margin?: string;
  padding?: string;
  justifycontent?: string;
  alignitems?:string;
  position?:"absolute" | "relative" | "sticky" | null;
  top?:number;
  width?:number | string;
  maxwidth?:string;
  minwidth?:string;
  height?:string;
  onClick?:() => void;
  placecontent?: string;
  justifyitems?: string;
  overflow?:string;
  aligncontent?:string;
  border?:string;
  flexwrap?: string;
  bgcolor?: string;
  borderradius?: string;
  flex?: string;
  minheight?: string;
  textalign?: string;
  style?: React.CSSProperties;
  className?: string;
}

const ContainerWrapper = styled.div<ContainerProps>`
  position: ${(props) => props.position};
  top:${(props) => props.top}px;
  display: ${(props) => props.display || "flex"};
  gap: ${({ gap }) => gap || "10px"};
  margin: ${({ margin }) => margin || "0"};
  padding: ${({ padding }) => padding || "0"};
  justify-content: ${(props) => props.justifycontent};
  align-items: ${(props) => props.alignitems};
  max-width: ${(props) => props.maxwidth};
  min-width: ${(props) => props.minwidth};
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "auto"};
  place-content:${(props) => props.placecontent};
  justify-items: ${(props) => props.justifyitems};
  overflow-y: ${(props) => props.overflow};
  align-content: ${(props) => props.aligncontent};
  border: ${(props) => props.border};
  flex-wrap: ${(props) => props.flexwrap};
  box-sizing: border-box;
`;

const Container = ({ children, ...rest }: ContainerProps) => {
  return <ContainerWrapper {...rest}>{children}</ContainerWrapper>;
};

export default Container;
